<div class="main-modal-container">
  <div class="close-modal-container">
    <img
      (click)="closeModal()"
      src="/assets/icons/ close-modal-icon.png"
      alt=""
    />
  </div>
  <div class="modal-content">
    <!-- Delete user modal -->
    <ng-container *ngIf="modalType == 'deleteUser'">
      <h1 class="label-title">Delete User</h1>
      <h3>Are you sure you want to delete this user?</h3>
      <button
        (click)="deleteUser()"
        class="modal-button"
        gbui-button
        [busy]="deleteUserLoading$ | async"
        type="submit"
      >
        Delete User
      </button>
    </ng-container>

    <!-- Delete user successfully modal -->
    <ng-container *ngIf="modalType == 'deleteUserSuccess'">
      <h1 class="label-title">Deleted Successfully</h1>
      <h3>The user has been deleted successfully.</h3>
      <button gbui-button class="modal-button" gbui-button type="submit">
        Back to Users
      </button>
    </ng-container>

    <!-- Updated user successfully modal -->
    <ng-container *ngIf="modalType == 'updatedUserSuccess'">
      <img
        class="modal-success-icon"
        src="/assets/icons/success-modal-icon.png"
        alt=""
      />
      <h1 class="label-title">Updated Succesfully</h1>
      <h3>Your profile has been updated successfully.</h3>
      <button class="modal-button" gbui-button type="submit">
        Back To Profile
      </button>
    </ng-container>

    <!-- Import file to user modal -->
    <ng-container *ngIf="modalType == 'importFile'">
      <h1 class="label-title">Import File</h1>
      <h3 class="import-file-description">
        Select the file to import to users
      </h3>

      <label class="select-file">Select File</label>
      <div class="upload-container">
        <label class="upload-title">{{
          fileName ? fileName : "File name"
        }}</label>
        <input
          (change)="uploadListener($event)"
          class="input-file"
          accept=".csv"
          type="file"
          name=""
          id=""
        />
        <button
          class="modal-button upload-button"
          gbui-button
          context="primary"
        >
          Upload
        </button>
      </div>
      <label for="" class="download-text" (click)="downloadFile()"
        >Click here to download the import format
      </label>
      <div class="button-save-container">
        <button
          [disabled]="!fileName"
          (click)="uploadFile()"
          class="modal-button save-button"
          gbui-button
          context="primary"
        >
          Save
        </button>
      </div>
    </ng-container>
  </div>
</div>
